import Vue from 'vue';
import dayjs from 'dayjs';

const yearOnly = value => {
    return value ? dayjs(value).format('YYYY') : '';
};

Vue.filter('yearOnly', yearOnly);
